// extracted by mini-css-extract-plugin
module.exports = {"loadingWrap":"customFacet_loadingWrap__RSJpj"};